import React from 'react';
import ReactMarkdown from 'react-markdown';

import { useGetConsultationCoachSupervisorQuery } from '../../services/consultation-results.api';

import { AiAssistantDisclaimer } from './ai-assistant-disclaimer';
import { AiAssistantMissingMessage } from './ai-assistant-missing-message';

type Props = {
  consultationId?: number;
  isGroupConsultation?: boolean;
};

export const AiCoachSupervisorTab = ({ consultationId, isGroupConsultation = false }: Props) => {
  const hasConsultationId = Boolean(consultationId);
  const { data, isFetching, isLoading, isError } = useGetConsultationCoachSupervisorQuery(
    consultationId ? consultationId.toString() : '',
    { skip: !hasConsultationId },
  );

  const renderCard = (children: React.ReactNode, variant: 'default' | 'error' = 'default') => {
    const baseClasses = 'p-1 lg:p-1 text-body-l lg:text-body-xl leading-relaxed space-y-4';
    const variantClasses = variant === 'error' ? 'text-primary' : 'text-ink-muted';

    return <div className={`${baseClasses} ${variantClasses}`}>{children}</div>;
  };

  if (!hasConsultationId) {
    return renderCard(<>Выберите запись, чтобы увидеть рекомендации коуч супервизора.</>);
  }

  if (isLoading || isFetching) {
    return renderCard(<p>Загружаем рекомендации ИИ коуч супервизора...</p>);
  }

  const coachSupervisor = data?.coachSupervisor ?? data?.coach_supervisor;

  if (isError || !coachSupervisor) {
    return renderCard(
      <AiAssistantMissingMessage assistant="ai-coach-supervisor" isGroupConsultation={isGroupConsultation} />,
      'error',
    );
  }

  return renderCard(
    <div className="text-ink text-ui lg:text-body-l leading-relaxed">
      <ReactMarkdown
        components={{
          p: (paragraphProps) => <p className="mt-3 mb-1 last:mb-0" {...paragraphProps} />,
        }}
      >
        {coachSupervisor}
      </ReactMarkdown>
      <AiAssistantDisclaimer assistant="ai-coach-supervisor" />
    </div>,
  );
};
